import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ChromePicker } from 'react-color';
import './_styles_/ColorField.css';
import useEffectOnUpdate from '../../hooks/useEffectOnUpdate';
import Field from './Field';
import { onActionKey } from '../../utils';
import { NO_STATE } from '../../hooks/useExtendedState';
import { extendedStateType } from '../../types';
import { resolveValue } from '../../utils/fields';

ColorField.propTypes = {
    label: PropTypes.node.isRequired,
    value: PropTypes.string,
    inputId: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string,
    onReset: PropTypes.func,
    isChanged: PropTypes.bool,
    isRequired: PropTypes.bool,
    state: extendedStateType,
};

ColorField.defaultProps = {
    value: undefined,
    inputId: null,
    onChange: undefined,
    className: '',
    onReset: undefined,
    isChanged: undefined,
    isRequired: false,
    state: NO_STATE,
};

function ColorField(props) {
    const {
        label,
        value,
        inputId,
        onChange,
        className,
        onReset,
        isChanged,
        isRequired,
        state,
    } = props;
    const stateValueSetter = state && state !== NO_STATE ? state.setValueIfNew : () => {};
    const resolvedValue = resolveValue(value, state);
    const [displayedValue, setDisplayedValue] = useState(resolvedValue);
    const setNewValue = (newValue) => {
        setDisplayedValue(newValue);
        stateValueSetter(newValue);
        onChange && onChange(newValue);
    };
    useEffectOnUpdate(() => {
        const newResolvedValue = resolveValue(value, state);
        setNewValue(newResolvedValue);
    }, [value, state.value]);
    const [isVisible, setVisible] = useState(false);
    const changeHandler = (newColor) => setNewValue(newColor.hex);
    const clickHandler = () => setVisible(!isVisible);
    const closeHandler = () => setVisible(false);
    return (
        <Field
            label={label}
            inputId={inputId}
            onReset={onReset}
            isChanged={isChanged}
            state={state}
            isRequired={isRequired && !displayedValue}
        >
            <div className={className}>
                <div tabIndex={0} onKeyUp={onActionKey(clickHandler)} role="button" className="icon-field--swatch icon-field--editable" onClick={clickHandler} aria-label={displayedValue}>
                    <div className="icon-field--color" style={{ background: displayedValue }} title={displayedValue} />
                </div>
                {isVisible && (
                    <div className="icon-field--popover">
                        <div
                            aria-label="X Color-Picker"
                            tabIndex={0}
                            onKeyUp={onActionKey(closeHandler)}
                            role="button"
                            className="icon-field--cover"
                            onClick={closeHandler}
                        />
                        <ChromePicker
                            color={displayedValue}
                            onChange={changeHandler}
                            disableAlpha
                        />
                    </div>
                )}
            </div>
        </Field>
    );
}

export default ColorField;
